import CartItem from '../cart/cartItem.js';


let Adr = function(adrData){
    "use strict";

    let deliveryDate;
    let orderFrequency;
    let shipImmediate;
    let contractType;
    let contractLength;
    let processAdrText;
    let fromCart;
    let ProductDiscountCode;
    let ShippingDiscountCode;

    // for adding to/replaceing an item in adr
    let id;                 // if exists meaning adr is being updated
    let replaceLineItem;    // if replacing the lineItem being replaced.
    let timestamp;          // timestamp on adr
    let itemInfos;          // if adding/updating adr then this is info on the items in the adr

    if (adrData && adrData !== null) {
        deliveryDate = adrData.deliveryDate;
        orderFrequency = adrData.orderFrequency ? adrData.orderFrequency : 1;
        shipImmediate = adrData.shipImmediate;
        contractType = adrData.contractType;
        contractLength = adrData.contractLength;
        processAdrText = adrData.processAdrText;
        fromCart = adrData.fromCart ? adrData.fromCart : false;
        ProductDiscountCode = adrData.ProductDiscountCode;
        ShippingDiscountCode = adrData.ShippingDiscountCode;

        id = adrData.id;
        if (adrData.replaceLineItem) {
            if (adrData.replaceLineItem instanceof CartItem) {
                replaceLineItem = adrData.replaceLineItem;
            } else {
                replaceLineItem = new CartItem(adrData.replaceLineItem);
            }
        }
        itemInfos = adrData.itemInfos;
        timestamp = adrData.timestamp;
    }

    this.toJSON = function() {
        let adr = {};
        adr.deliveryDate = deliveryDate;
        adr.orderFrequency = orderFrequency;
        adr.shipImmediate = shipImmediate;
        adr.contractType = contractType;
        adr.contractLength = contractLength;
        adr.processAdrText = processAdrText;
        adr.fromCart = fromCart;
        adr.id = id;
        adr.replaceLineItem = replaceLineItem ? replaceLineItem.toJSON() : null;
        adr.itemInfos = itemInfos;
        adr.timestamp = timestamp;
        adr.ProductDiscountCode = ProductDiscountCode;
        adr.ShippingDiscountCode = ShippingDiscountCode;
        return adr;
    };

    // ---------------------------------------------
    //
    //        Public Getter / Setter Methods
    //
    // ---------------------------------------------
    Object.defineProperties(this, {
        productDiscountCode: {
            get: function () {
                return ProductDiscountCode;
            },
            set: function (_ProductDiscountCode) {
                ProductDiscountCode = _ProductDiscountCode;
            }
        },
        shippingDiscountCode: {
            get: function () {
                return ShippingDiscountCode;
            },
            set: function (_ShippingDiscountCode) {
                ShippingDiscountCode = _ShippingDiscountCode;
            }
        },
        deliveryDate: {
            get: function () {
                return deliveryDate;
            },
            set: function (_deliveryDate) {
                deliveryDate = _deliveryDate;
            }
        },
        orderFrequency: {
            get: function () {
                return orderFrequency;
            },
            set: function (_orderFrequency) {
                orderFrequency = _orderFrequency;
            }
        },
        shipImmediate: {
            get: function () {
                if (typeof shipImmediate == 'string') {
                    return shipImmediate === 'true';
                } else {
                    return shipImmediate;
                }
            },
            set: function (_shipImmediate) {
                shipImmediate = _shipImmediate;
            }
        },
        contractLength: {
            get: function () {
                return contractLength;
            },
            set: function (_contractLength) {
                contractLength = _contractLength;
            }
        },
        contractType: {
            get: function () {
                return contractType;
            },
            set: function (_contractType) {
                contractType = _contractType;
            }
        },
        processAdrText: {
            get: function () {
                return processAdrText;
            },
            set: function (_processAdrText) {
                processAdrText = _processAdrText;
            }
        },
        fromCart: {
            get: function () {
                return fromCart;
            },
            set: function (_fromCart) {
                fromCart = _fromCart;
            }
        },
        id: {
            get: function () {
                return id;
            },
            set: function (_id) {
                id = _id;
            }
        },
        replaceLineItem: {
            get: function () {
                return replaceLineItem;
            },
            set: function (_replaceLineItem) {
                replaceLineItem = _replaceLineItem;
            }
        },
        itemInfos: {
            get: function() {
                return itemInfos;
            },
            set: function(_itemInfos) {
                itemInfos = _itemInfos;
            }
        },
        timestamp: {
            get: function () {
                return timestamp;
            },
            set: function (_timestamp) {
                timestamp = _timestamp;
            }
        }
    });
};

export default Adr;
